import { createSelector } from 'reselect';
import ItemOverviewV1Columns
  from '../../containers/ItemOverviewV1Columns';
import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.ITEM_OVERVIEW_V1_200.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.ITEM_OVERVIEW_V1_200.isLoading;

export const getData =
  ReportsDefinition.ITEM_OVERVIEW_V1_200.getDataFunction();

export const getColumns =
  createSelector(getData, ItemOverviewV1Columns);
